var winheight = window.innerHeight;
var app;

function App() {
	var self = this;
	// this.touch = Modernizr.touch;
	this.photoswipe = false;
	this.mq = false;
	this.init();
	this.common();
}

App.prototype.init = function() {
	var self = this;
	this.accordions = new Accordions();
	this.handleModalFocusEvents();
	this.handleFixed();
	this.handleButtons();
	// this.cookies = new Cookies();
	this.cart = new Cart();
	this.slick = new Slick();
	this.tabs = new Tabs();
	this.photoswipe = new initPhotoSwipe();
	this.favorites = new Favorites();
	self.profiles = new Profiles();
	this.handleCustomSelectEvents();
	this.handleNewsletterPopup();
	this.handleDeleteaccountPopup();
	this.setComponentHeights();
	this.handleBackToTopButton();
	this.handleCategoryMenu();
	this.handleProductBackButton();
	this.handleNewsBackButton();
	this.handleOutOfStockPopup();
	this.handleRegisterFormOptions();
	$(window).on('resize', this, this.handleWindowResize);
};

App.prototype.common = function() {
	$('body').on('click', '.account-logout', function(e){
		e.preventDefault();
		window.localStorage.clear();
		location.href = $(this).attr('href');
	});

	//popupy
	$(document).ready(function() {
		if (show_popup_login) {
			$('.login-overlay').addClass('-active');
		}
		if (show_popup_password) {
			$('.remind-password-overlay').addClass('-active');
		}
		if (show_popup_register) {
			$('.register-overlay').addClass('-active');
			if (show_popup_register == 2) {
				$('.register-step1').addClass('-hidden');
				$('.register-step2').addClass('-visible');
			}
		}

		$('.register-btn').on('click', function(e){
			e.preventDefault();
			var b = this;
			if ($('input[name=reg-accept]')[0].checked) {
				if ($('input[name=reg-accept2]')[0].checked) {
					window.location.href = $(b).attr('data-url');
				} else {
					$('.reg-accept2').addClass('error').closest('.input-container').addClass('-input-error');
				}
			} else {
				$('.reg-accept').addClass('error').closest('.input-container').addClass('-input-error');
			}
		});
	});

	//autocomplete
	var autocomplete_cache = {};
	$( function() {
		$( "#gsearch" ).autocomplete({
			//source: availableTitle
			appendTo: ".navbar-search",
			position: { my: "left top-3", at: "left bottom", collision: "none"},
			source: function( request, response ) {
				var search = request.term;
				if (autocomplete_cache[ search ]) {
					response( autocomplete_cache[search] );
				}
				else {
					$.ajax({
						url: "/search_autocomplete", 
						type: "POST",
						dataType: "json",
						data: {search: search},
						success: function( result ) {
							autocomplete_cache[search] = result;
							//console.log(result);
							//response( result );
							response($.map(result, function (item) {
								return {
									label: item.label,
									value: item.value
								};
							}));
						}
					});
				}
			},
			focus: function( event, ui ) {
				$( "#gsearch" ).val( ui.item.label );
				return false;
			},
			select: function ( event, ui) {
				var title = ui.item.label;
				//console.log(title);
				$("input[name=gsearch]").val(title);
				document.getElementById("wf-form-Search-Form-1").submit();
				return false;
			},
			open: function () {
				$('.navbar-search .ui-autocomplete').niceScroll({
					nativeparentscrolling: false,
					cursorcolor: "#D2373B",
					cursorwidth: "12px",
					background: "#ffffff",
					cursorborder: "0",
					cursorborderradius: 0,
					autohidemode: false,
					directionlockdeadzone: 0,
				});
			}
		})
		.autocomplete( "instance" )._renderItem = function( ul, item ) {
			return $( "<li>" )
				.append( "<div>" + item.label + "</div>" )
				.appendTo( ul );
		};
  } );

};

App.prototype.destroy = function() {
};

App.prototype.handleRegisterFormOptions = function() {
	var self = this;

	$('form.register-overlay-form').find('[name="reg-client-type"]').on('input', function() {
		if ($(this).val() == 1) {
			$('.register-overlay-form-group.-faktura').find('input').attr('disabled', 'disabled');
			$('.register-overlay-form-group.-faktura').addClass('-hidden');
			$('.-klient').removeClass('-hidden');
		} else {
			$('.register-overlay-form-group.-faktura').find('input').removeAttr('disabled');
			$('.register-overlay-form-group.-faktura').removeClass('-hidden');
			$('.-klient').addClass('-hidden');
		}
	});
};

App.prototype.handleOutOfStockPopup = function() {
	var self = this;

	$('form.outofstock-form').on('submit', function(e) {
		e.preventDefault();
		var f = $(this);
		
		$('.outofstock-product-id').val( $('.product').attr('data-id') );
		// console.log($('.outofstock-product-id').val());

		$.ajax({
			type: 'POST',
			url: f.attr('action'),
			data: f.serialize(),
			dataType: 'json',
			success: function(data) {
				if (data.fails) {
					//console.log(data.errors);
					for (var name in data.errors) {
						var span = f.find('span[data-input="'+name+'"]');
						//console.log(span.length);
						$('input[name="'+name+'"]').addClass('error');
						if (span.length) {
							span.html(data.errors[name][0]).addClass('-active').parent().addClass('error');
						}
					}
					$(window).scrollTop( $('div.error').first().offset().top - 120);
				} else {
					//next-step
					$('.outofstock-overlay').addClass('-success');
				}
			}
		});

	});

	$('a.outofstock, .outofstock-popup').on('click', function(e) {
		e.preventDefault();
		var img, title;
		$('.outofstock-overlay').removeClass('-success');
		if ($(this).hasClass('outofstock-popup')) {
			img = $(this).closest('.catalogue-item').find('.catalogue-item-image').find('img').attr('src');
			$('.outofstock-overlay').find('.cartadded-cover').attr('src', img);
			title = $(this).closest('.catalogue-item').find('.catalogue-item__title').text();
			$('.outofstock-overlay').find('.cartadded-header__heading').text(title);
		} else {
			img = $('.product-gallery-image .slick-slide:first-child img').attr('src');
			$('.outofstock-overlay').find('.cartadded-cover').attr('src', img); 
			title = $('.product-info').find('.product-info__title').text();
			$('.outofstock-overlay').find('.cartadded-header__heading').text(title);
		}

		$('.outofstock-overlay').addClass('-active');
	});
};

App.prototype.handleProductBackButton = function() {
	var self = this;
	
	$('.catalogue-item').on('click', function() {
		sessionStorage.setItem('productBackButton', 1);
	});

	if (sessionStorage.getItem('productBackButton')) {
		// $('.section-product .nav-back').removeClass('-button-hidden');
		$('.section-product .nav-back').on('click', function(e) {
			e.preventDefault();
			window.history.go(-1);
		});
	} else {
		// $('.section-product .nav-back').addClass('-button-hidden');
	}
};

App.prototype.handleNewsBackButton = function() {
	var self = this;
	
	$('.news-item').on('click', function() {
		sessionStorage.setItem('newsBackButton', 1);
	});

	if (sessionStorage.getItem('newsBackButton')) {
		// $('.section-news .nav-back').removeClass('-button-hidden');
		$('.section-news .nav-back').on('click', function(e) {
			e.preventDefault();
			window.history.go(-1);
		});
	} else {
		// $('.section-news .nav-back').addClass('-button-hidden');
	}
};

App.prototype.handleBackToTopButton = function() {
	var self = this;
	$('.footer-lift').on('click', function(e) {
		e.preventDefault();
		$(window).scrollTo(0, 500);
	});
};

App.prototype.handleCategoryMenu = function() {
	var self = this;

	$('.catalogue-menu-link').hoverIntent(
		function() {
			$(this).siblings().removeClass('-active');
			$(this).addClass('-active');
		},
		function() {}
	);

	$('.catalogue-menu').hoverIntent(
		function() {},
		function() {
			$(this).find('.catalogue-menu-link').removeClass('-active');
		}
	);
};

App.prototype.handleModalFocusEvents = function () {
	$(document).on('keydown', function(e) {
		if(e.key === "Escape" && $('.body-overlay').hasClass('-active')) {
			$('.body-overlay').removeClass('-active');
		}
	});

	$('.body-overlay').on('keydown', '.w-checkbox, .w-radio', function(e) {
		if(e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
			$(this).find('input').click();
		}
	});

	function getFocusable(m){
		return m.find('input:not([type="hidden"]), button, select, textarea, a[href], [tabindex]:not([tabindex="-1"])');
	}

	$('.body-overlay').on('transitionend', function() {
		var modal = $(this);
		var elems = getFocusable(modal);
		var first = elems.first()[0];
		var last = elems.last()[0];
		first.focus();

		if(modal.hasClass('-active')) {
			modal.on('keydown', function(e) {
				if(e.key === "Tab" && e.shiftKey && document.activeElement === first) {
					e.preventDefault();
					last.focus();
				}
				if(e.key === "Tab" && !e.shiftKey && document.activeElement === last) {
					e.preventDefault();
					first.focus();
				}
			});
		} else {
			modal.off('keydown');
		}
	});
};

App.prototype.handleButtons = function() {
	var self = this;
	$('.product-description-readmore__link').click(function(e) {
		e.preventDefault();
		$('.product-description__text').addClass('product-description__text--active');
	});

	$('.catalogue-content-category-text a.readmore').click(function(e) {
		e.preventDefault();
		$(this).parent().addClass('catalogue-content-category-text--active');
	});

	$('.catalogue-content-category-text a.readmore-hide').click(function(e) {
		e.preventDefault();
		$(this).parent().removeClass('catalogue-content-category-text--active');
	});

	$('.catalogue-item-icons__icon').on('keydown', function(e) {
		if(e.key === "Spacebar") {
			$(this).click();
		}
	});

	$('.cartadded-overlay.body-overlay, .outofstock-overlay.body-overlay, .body-overlay__close').on('click', function(e) {
		$('body').removeClass('-menu-mobile-open');
		$('.body-overlay').removeClass('-active');
		if ($(this).hasClass('-go-home') || $(this).closest('.body-overlay').hasClass('-go-home')) {
			window.location.href = '/';
		}
		if ($(this).hasClass('-new-client') || $(this).closest('.body-overlay').hasClass('-new-client')) {
			window.location.href = '/';
		}
	});
	
	$('.body-overlay-wrapper').on('click', function(e) {
		e.stopPropagation();
	});

	$('.navbar-menu--mobile').on('click keydown', function(e) {
		if (e.type === "keydown" && (e.key == "Enter" || e.keyCode === 32 ) || e.type === "click") {
			if (e.type == "keydown") {
				$('.menu-mobile a:first').focus();
			}
			e.stopPropagation();
			e.preventDefault();
			$(window).scrollTo(0, 0);
			$('.menu-mobile').toggleClass('-active');
			$('body').toggleClass('-menu-mobile-open');
		}
	});
	$('.menu-mobile-search-icon').on('click', function(e) {
		e.stopPropagation();
		$('.menu-mobile').addClass('-search');
	});

	$('.navbar-menu--desktop').on('click keydown', function(e) {
		if (e.type === "keydown" && (e.key == "Enter" || e.keyCode === 32 ) || e.type === "click") {
			if (e.type == "click") {
				e.stopPropagation();
			}
			e.preventDefault();
			$('.menu-desktop').toggleClass('-active');
			$('body').toggleClass('-menu-desktop-open');
			$('.menu-desktop a:first').focus();
		}
	});

	$('.menu-desktop, .menu-mobile').on('click', function(e) {
		e.stopPropagation();
	});

	function toggleAriaExpandedCatalogue(e) {
		var expandedVal = $(e).attr('aria-expanded') === 'false' ? 'true' : 'false';
		$(e).attr('aria-expanded', expandedVal);
	}

	$('.navbar-catalogue-wrapper').on('mouseenter mouseleave', function() {
		toggleAriaExpandedCatalogue('.navbar-catalogue');
	});
	$('.navbar-catalogue').on('keydown', function(e) {
		if(e.key === " " || e.key === "Spacebar") {
			e.preventDefault();
			$('.navbar-catalogue-wrapper').toggleClass('-active');
			toggleAriaExpandedCatalogue(this);
			$('.menu-catalogue a:first').focus();
		}
	});
	$(document).on('keydown', function(e) {
		if(e.key === "Escape" && $('.navbar-catalogue-wrapper').hasClass('-active')) {
			$('.navbar-catalogue-wrapper').removeClass('-active');
			toggleAriaExpandedCatalogue('.navbar-catalogue');
		}
	});
    $('.menu-catalogue a:first').on('keydown', function(e) {
		if (e.key === "Tab" && e.shiftKey) {
			$('.navbar-catalogue-wrapper').removeClass('-active');
			toggleAriaExpandedCatalogue('.navbar-catalogue');
		}
	});
	$('.menu-catalogue a:last').on('keydown', function(e) {
		if (e.key === "Tab" && !e.shiftKey) {
			$('.navbar-catalogue-wrapper').removeClass('-active');
			toggleAriaExpandedCatalogue('.navbar-catalogue');
		}
	});

	function closeMenuDesktopWithFocus() {
		$('.menu-desktop').removeClass('-active');
		$('body').removeClass('-menu-desktop-open');
		$('.navbar-menu--desktop').focus();
	}
	$('.menu-desktop a:first').on('keydown', function(e) {
		if (e.key === "Tab" && e.shiftKey) {
			e.preventDefault();
			closeMenuDesktopWithFocus();
		}
	});
	$('.menu-desktop a:last').on('keydown', function(e) {
		if (e.key === "Tab" && !e.shiftKey) {
			e.preventDefault();
			closeMenuDesktopWithFocus();
		}
	});

	function closeMenuMobileWithFocus() {
		$('.menu-mobile').removeClass('-active');
		$('body').removeClass('-menu-mobile-open');
		$('.navbar-menu--mobile').focus();
	}
	$('.menu-mobile w-dropdown-toggle:first').on('keydown', function(e) {
		if (e.key === "Tab" && e.shiftKey) {
			e.preventDefault();
			closeMenuMobileWithFocus();
		}
	});
	$('.menu-mobile a:last').on('keydown', function(e) {
		if (e.key === "Tab" && !e.shiftKey) {
			e.preventDefault();
			closeMenuMobileWithFocus();
		}
	});

	$(document).on('click', function() {
		$('.menu-desktop, .menu-mobile').removeClass('-active');
		$('body').removeClass('-menu-mobile-open').removeClass('-menu-desktop-open');
	});

	function showLoginOverlay() {
		$('.body-overlay').removeClass('-active');
		$('.login-overlay').addClass('-active');
		$('.menu-desktop, .menu-mobile').removeClass('-active');
	}

	$('.-show-login').on('click', function() {
		showLoginOverlay();
	});
	$('.-show-login').on('keydown', function(e) {
		if(e.key === "Enter") {
			showLoginOverlay();
		}
	});

	$('.-lost-password').on('click', function(e) {
		e.preventDefault();
		$('.body-overlay').removeClass('-active');
		$('.remind-password-overlay').addClass('-active');
	});

	$('.-register').on('click', function() {
		$('.body-overlay').removeClass('-active');
		$('.register-overlay').addClass('-active');
		$('.register-step1').removeClass('-hidden');
		$('.register-step2').removeClass('-visible');
	});

	$('.search-overlay').on('click', function(e) {
		e.stopPropagation();
		$('.menu-mobile').addClass('-active');
		$('.menu-mobile').addClass('-search');
		$('body').addClass('-menu-mobile-open');
		$(window).scrollTop(0);
		$('.navbar-search-form__input').focus();
	});

	$('.news-item .news-item-readmore').on('click', function(e) {
		if ($(this).find('a').attr('href') == "#") {
			e.preventDefault();
			$(this).closest('.news-item').toggleClass('news-item--readmore');
		}
	});

	$('.remind-password-overlay form').submit(function() {console.log('here');
		$(this).closest('.body-overlay-wrapper').find('.remind-password-overlay-active').hide();
		$(this).closest('.body-overlay-wrapper').find('.remind-password-overlay-done').addClass('-active');
	});

};

App.prototype.handleDeleteaccountPopup = function() {
	var self = this;

	var form = $('#deleteaccount-form');
	var data = form.serialize();
	var url = '/profiles/deleteaccount';

	$('.deleteaccount-popup').on('click', function(e) {
		e.preventDefault();
		$('.done').removeClass('-visible').addClass('-hidden');
		$('.info').removeClass('-hidden').addClass('-visible');
		$('.btn-content').removeClass('-hidden').addClass('-visible');
		$('.account-overlay').removeClass('done');
		$('.account-overlay').addClass('-active');
	});

	$('.cancel-btn').on('click', function(e) {
		e.preventDefault();
		$('.account-overlay').removeClass('-active');
	});

	$('.account-overlay').on('click', function(e) {
		if ($(this).closest('.account-overlay').hasClass('done'))
			$('.account-overlay').removeClass('-active');
	});

	$('.deleteaccount').on('click', function(e) {
		e.preventDefault();
		$.ajax({
			url: url, 
			type: "POST",
			dataType: "json",
			data: data,
			success: function( data ) {
				$('.account-overlay').addClass('done');
				$('.info').removeClass('-visible').addClass('-hidden');
				$('.done').removeClass('-hidden').addClass('-visible');
				$('.btn-content').removeClass('-visible').addClass('-hidden');
			}
		});
	});
};

App.prototype.handleNewsletterPopup = function() {
	var self = this;

	function ariaInputCheck(e) {
		if(!e.prop('checked')) {
			e.attr('aria-checked', false);
		} else {
			e.attr('aria-checked', true);
		}
	}

	$('.input-container--checkbox').on('click', function(e) {
		e.stopPropagation();
		var input = $(this).find('.w-checkbox-input');
		ariaInputCheck(input);
    });

	$('.input-container--checkbox').on('keydown', function(e) {
		e.stopPropagation();
		if(e.key === "Enter") {
			var input = $(this).find('.w-checkbox-input');
			input.click();
			ariaInputCheck(input);
		}
    });

	$('.newsletter-form__input').on('input', function() {
		var val = $(this).val();
		$('.newsletter-overlay-form__email').val(val);
	});

	$('.newsletter-overlay-form__email').on('input', function() {
		var val = $(this).val();
		$('.newsletter-form__input').val(val);
	});

	$('.newsletter-form').on('submit', function(e) {
		e.preventDefault();
		$('.w-form-done').removeClass('-visible');
		$('.w-form-fail').removeClass('-visible');
		$('.newsletter-overlay-form').removeClass('-hidden');
		$('.newsletter-overlay').addClass('-active');
	});

	$('.newsletter-form__submit').on('click', function(e) {
		if (grecaptcha)
			grecaptcha.execute();
		$('.w-form-done').removeClass('-visible');
		$('.w-form-fail').removeClass('-visible');
		$('.newsletter-overlay-form').removeClass('-hidden');
		$('.newsletter-overlay').addClass('-active');
	});

	$('#newsletter-form-2').on('submit', function(e) {
		e.preventDefault();
		var form = $('#newsletter-form-2');
		var data = form.serialize();
		var url = '/newsletter';
		//console.log(data);
		$(form).find('.-input-error').removeClass('-input-error');
		$.ajax({
			url: url, 
			type: "POST",
			dataType: "json",
			data: data,
			success: function( data ) {
				if (data.fails == false) {
					//ok
					$('.w-form-done').addClass('-visible');
					$('.newsletter-overlay-form').addClass('-hidden');
				} else {
					//$('.w-form-fail').addClass('-visible');
					//$('.newsletter-overlay-form').addClass('-hidden');
					for (var name in data.errors) {
						var span = form.find('span[data-input="'+name+'"]');
						$('input[name="'+name+'"]').addClass('-input-error');
						if (span.length) {
							span.html(data.errors[name][0]).addClass('-active').parent().addClass('-input-error');
						}
					}
					//$(window).scrollTop( $('div.error').first().offset().top - 120);
				}
			}
		});
	});

	$('.body-overlay__close').on('click', function(e){
		$('.newsletter-overlay-form').removeClass('-hidden');
		$('.w-form-fail').removeClass('-visible');
		$('.newsletter-overlay').remove('-active');
		$('.w-form-done').removeClass('-visible');
		$('body').removeClass('-menu-mobile-open').removeClass('-menu-desktop-open');
	});
};

App.prototype.handleCustomSelectEvents = function() {
	var self = this;

	$('body').on('click', '.dropdown-wrapper', function(e) {
		e.stopPropagation();
		e.preventDefault();
		if ($(this).hasClass('-visible')) {
			$(this).removeClass('-visible');
		} else {
			$('.dropdown-wrapper').removeClass('-visible');
			$(this).addClass('-visible');
		}
	});

	$('body').on('click', '.dropdown-wrapper .select-dropdown-element', function() {
		var text = $(this).find('.tab-block__text').text();
		var form = $(this).closest('.dropdown-wrapper').attr('data-name');
		var value = $(this).attr('data-value');
		var dropdown = $(this).closest('.dropdown-wrapper');
		$(this).closest('.dropdown-wrapper').find('.select-box__text').text(text);
		$(this).siblings().removeClass('-active');
		$(this).addClass('-active');
		if ($(this).attr('data-value') == 0)
			dropdown.addClass('-default-item-picked');
		else
			dropdown.addClass('-item-picked');
		var oldValue = $(this).closest('.select-block').find('input[name="'+form+'"]').val();
		$(this).closest('.select-block').find('input[name="'+form+'"]').val(value);
		if (oldValue != value) {
			$(this).closest('.select-container').removeClass('filter-done');
		}
		//ajax koszyk po zmianie kraju roboczo
		if (form=='country') {
			//console.log('Wybrano ' + $(this).attr('data-value'));
			ajax_cart();
		}
	});

	$('body').on('click', '.dropdown-wrapper .select-box__remove', function(e) {
		
		e.stopPropagation();

		var input = $(this).closest('.select-block').find('input[type="hidden"]');
		var first_val = $(this).closest('.dropdown-wrapper').find('.select-dropdown-wrapper').find('.select-dropdown-element').first().attr('data-value');
		var text;

		$(this).closest('.dropdown-wrapper').find('.select-dropdown-wrapper').find('.select-dropdown-element').removeClass('-active');
		// $(this).closest('.dropdown-wrapper').find('.select-dropdown-wrapper').find('.select-dropdown-element').first().addClass('-active');

		if ($(this).closest('.dropdown-wrapper').attr('data-default') && $(this).closest('.dropdown-wrapper').attr('data-default') != "") {
			input.val('');
			text = $(this).closest('.dropdown-wrapper').attr('data-default');
		} else {
			text = $(this).closest('.dropdown-wrapper').find('.select-dropdown-wrapper').find('.select-dropdown-element.-active').text();
			input.val(first_val);
		}
		
		var dropdown = $(this).closest('.dropdown-wrapper');

		$(this).closest('.dropdown-wrapper').find('.select-box__text').text(text);
		$(this).closest('.dropdown-wrapper').removeClass('-item-picked').addClass('-default-item-picked');
	});

	$('body').on('click', function() {
		$('.dropdown-wrapper').removeClass('-visible');
	});
};

App.prototype.handleFixed = function() {
	$('.fixed').each(function() {
		var parent = $(this).parent();
		$(this).css({width:parent.innerWidth(),height:parent.innerHeight()+"px"});
	});
};

App.prototype.setComponentHeights = function() {
	var self = this;
	$('.sticky').each(function() {
		$(this).width($(this).parent().width());
		$(this).affix('checkPosition');
		if ($(this).innerHeight() >= $(this).closest('.row').innerHeight())
			$(this).addClass('-blocked');
		else
			$(this).removeClass('-blocked');
	});
};

App.prototype.animateAffix = function(time) {
	// $('.sticky').affix('checkPosition');
	app.affixAnimationID = requestAnimationFrame(app.animateAffix);
};

App.prototype.handleWindowResize = function(e) {
	var self = this;
	winheight = window.innerHeight;
	e.data.handleFixed();
	e.data.setComponentHeights();
	self.mq = /\w+/g.exec(window.getComputedStyle(document.querySelector('body'), ':after').getPropertyValue('content'))[0];
};

$(document).ready(function() {
	// PointerEventsPolyfill.initialize({});
	app = new App();
	// to top right away
    if ( window.location.hash ) scroll(0,0);
    // void some browsers issue
    setTimeout( function() { scroll(0,0); }, 1);
    // any position
    $(function() {
        // *only* if we have anchor on the url
        if(window.location.hash) {
            // smooth scroll to the anchor id
            $('html, body').animate({
                scrollTop: $(window.location.hash).offset().top + 'px'
            }, 1000, 'swing');
        }
    });
});